import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import "./Profile.css";

import ProfileHero
  from "./components/ProfileHero";

import AchievementGrid
  from "./components/AchievementGrid";

import JourneyTimeline
  from "./components/JourneyTimeline";

import VisionNavbar
  from "../VisionNavbar";


const Profile = () => {

  /* =====================================================
     EMAIL
  ===================================================== */

  const email =
    localStorage.getItem(
      "user_email"
    );


  /* =====================================================
     STATES
  ===================================================== */

  const [
    loading,
    setLoading
  ] = useState(true);


  const [
    profile,
    setProfile
  ] = useState(null);


  const [
    dashboard,
    setDashboard
  ] = useState(null);


  const [
    error,
    setError
  ] = useState("");


  /* =====================================================
     HIDE WEBSITE NAVBAR / FOOTER
  ===================================================== */

  useEffect(() => {

    const navbar =
      document.querySelector(
        "header, .navbar"
      );

    const footer =
      document.querySelector(
        "footer"
      );


    if (navbar)
      navbar.style.display =
        "none";


    if (footer)
      footer.style.display =
        "none";


    return () => {

      if (navbar)
        navbar.style.display =
          "";


      if (footer)
        footer.style.display =
          "";

    };

  }, []);


  /* =====================================================
     LOAD PROFILE
  ===================================================== */

  const loadProfile =
    async () => {

      try {

        setLoading(true);

        setError("");


        const [

          profileRes,

          dashboardRes

        ] = await Promise.all([


          axios.get(

            `/api/profile/${encodeURIComponent(
              email
            )}`

          ),


          axios.get(

            `/api/dashboard/${encodeURIComponent(
              email
            )}`

          )

        ]);


        console.log(
          "PROFILE RESPONSE:",
          profileRes.data
        );


        console.log(
          "DASHBOARD RESPONSE:",
          dashboardRes.data
        );


        /* =================================================
           SET PROFILE
        ================================================= */

        setProfile(
          profileRes.data
        );


        /* =================================================
           SET DASHBOARD
        ================================================= */

        setDashboard(
          dashboardRes.data
        );


        /* =================================================
           GET USER
        ================================================= */

        const user =
          profileRes.data?.user ||
          profileRes.data;


        /* =================================================
           PROFILE PHOTO
        ================================================= */

        const photo =
          user?.profilePhoto ||
          "";


        console.log(
          "PROFILE PHOTO:",
          photo
        );


        if (photo) {

          localStorage.setItem(

            "profile_photo",

            photo

          );


          /* ===============================================
             UPDATE VISION NAVBAR
          =============================================== */

          window.dispatchEvent(

            new CustomEvent(

              "profileUpdated",

              {

                detail: {

                  photo

                }

              }

            )

          );

        }


        /* =================================================
           LEVEL
        ================================================= */

        const backendLevel =
          Number(

            dashboardRes.data?.level

          ) || 1;


        localStorage.setItem(

          "user_level",

          String(
            backendLevel
          )

        );


        /* ===============================================
           UPDATE VISION NAVBAR LEVEL
        =============================================== */

        window.dispatchEvent(

          new CustomEvent(

            "profileUpdated",

            {

              detail: {

                level:
                  backendLevel

              }

            }

          )

        );

      }

      catch (err) {

        console.error(
          "Profile Load Error:",
          err
        );


        setError(
          "Unable to load profile."
        );

      }

      finally {

        setLoading(false);

      }

    };


  /* =====================================================
     INITIAL LOAD
  ===================================================== */

  useEffect(() => {

    if (email) {

      loadProfile();

    }
    else {

      setLoading(false);

      setError(
        "User email not found."
      );

    }

  }, [email]);


  /* =====================================================
     PHOTO UPLOAD
  ===================================================== */

  const handleUpload =
    async (file) => {

      try {

        if (!file) {

          return;

        }


        const formData =
          new FormData();


        formData.append(

          "photo",

          file

        );


        formData.append(

          "email",

          email

        );


        console.log(
          "Uploading profile photo..."
        );


        const response =
          await axios.post(

            "/api/upload-profile-photo",

            formData,

            {

              headers: {

                "Content-Type":
                  "multipart/form-data"

              }

            }

          );


        console.log(
          "UPLOAD RESPONSE:",
          response.data
        );


        /* =================================================
           GET PHOTO URL
        ================================================= */

        const photoUrl =
          response.data?.photoUrl;


        if (photoUrl) {

          console.log(
            "NEW PROFILE PHOTO:",
            photoUrl
          );


          /* ===============================================
             SAVE LOCAL STORAGE
          =============================================== */

          localStorage.setItem(

            "profile_photo",

            photoUrl

          );


          /* ===============================================
             UPDATE NAVBAR IMMEDIATELY
          =============================================== */

          window.dispatchEvent(

            new CustomEvent(

              "profileUpdated",

              {

                detail: {

                  photo:
                    photoUrl

                }

              }

            )

          );

        }


        /* =================================================
           RELOAD PROFILE
        ================================================= */

        await loadProfile();

      }

      catch (err) {

        console.error(

          "Profile Photo Upload Error:",

          err

        );

      }

    };


  /* =====================================================
     LOADING
  ===================================================== */

  if (loading) {

    return (

      <div className="profile-loading">

        Loading...

      </div>

    );

  }


  /* =====================================================
     ERROR
  ===================================================== */

  if (error) {

    return (

      <div className="profile-error">

        {error}

      </div>

    );

  }


  /* =====================================================
     SAFETY
  ===================================================== */

  if (!profile) {

    return (

      <div className="profile-error">

        Profile data not available.

      </div>

    );

  }


  /* =====================================================
     PROFILE DATA
  ===================================================== */

  const {

    user,

    stats,

    journey,

    summary,

    allAchievements

  } = profile;


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <>

      <VisionNavbar
        active="measure"
      />


      <div className="Vision-profile-page">


        {/* =================================================
            HERO
        ================================================= */}

        <ProfileHero

          user={user}

          stats={stats}

          summary={summary}

          achievements={
            allAchievements
          }

          onUpload={
            handleUpload
          }

        />


        {/* =================================================
            ACHIEVEMENTS
        ================================================= */}

        <section
          className="Vision-profile-section"
        >

          <div
            className="section-header"
          >

            <div>

              <span
                className="section-subtitle"
              >

                ACHIEVEMENTS

              </span>


              <h2>

                Achievement Collection

              </h2>


              <p>

                Unlock every badge by
                improving your visual and
                cognitive performance.

              </p>

            </div>

          </div>


          <AchievementGrid

            achievements={
              allAchievements
            }

            email={
              user.email
            }

            refreshProfile={
              loadProfile
            }

          />

        </section>


        {/* =================================================
            JOURNEY
        ================================================= */}

        <section
          className="Vision-profile-section"
        >

          <div
            className="section-header"
          >

            <div>

              <span
                className="section-subtitle"
              >

                JOURNEY

              </span>


              <h2>

                Your Vision Journey

              </h2>


              <p>

                Track your progress from
                Aware to Thriver.

              </p>

            </div>

          </div>


          <JourneyTimeline

            level={
              stats.currentLevel
            }

            journey={
              journey
            }

          />

        </section>


      </div>

    </>

  );

};


export default Profile;